<template>
  <div id="wrap">
    <div class="flex flex-start">
      <el-form :model="queryParams" ref="formName" :inline="true">
        <div>
          <el-form-item label="时间" prop="time">
            <el-date-picker
              v-model="queryParams.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="timeChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">搜索</el-button>
            <el-button type="primary" @click="resetQuery">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>

    <!-- <el-row class="back">
      <div class="txt" style="font-size:12px;">已选择<span style="color:#4988df;"> 0 </span>项</div>
      <router-link to="/goods/Goods2">
        <el-button type="primary" round class="add">新增</el-button>
      </router-link>
    </el-row> -->
    <div class="flex flex-end">
      <!-- <router-link :to="{path:'/ChinaHigh/registrationForm',query:'0'}"> -->
      <el-button type="primary" @click="addClick">新增</el-button>
      <!-- </router-link> -->
    </div>
    <el-table
      class="table"
      v-loading="loading"
      :data="datas"
      :header-cell-style="{ background: '#F5F7FA' }"
      stripe
      :row-class-name="tableRowClassName"
    >
      <el-table-column label="序号" width="60" prop="index">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="projectNumber"
        label="项目编号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="创建人" prop="createBy"></el-table-column>
      <el-table-column
        label="创建时间"
        show-overflow-tooltip
        prop="createTime"
      ></el-table-column>
      <el-table-column label="完成度" prop="integrity">
        <template slot-scope="scope">
          <span>{{ (Number(scope.row.integrity) / 10) * 100 }}%</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120" prop="materialGenerateState">
        <template slot-scope="scope">
          <span>{{ status[scope.row.materialGenerateState] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <router-link
            :to="{
              path: '/ChinaHigh/registrationForm',
              query: { id: scope.row.id },
            }"
          >
            <el-button type="text" size="small" class="green">编辑</el-button>
          </router-link>
          <el-button
            type="text"
            size="small"
            class="red"
            @click="handleDelete(scope.row.id)"
            >删除</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.materialGenerateState == 1"
            @click="handleDownload(scope.row.materialGenerateUrl)"
            size="small"
            class="blue"
            >下载</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="flex flex-end">
      <el-pagination
        background
        v-show="total > 0"
        :total="total"
        :current-page.sync="queryParams.pageNum"
        :page-size.sync="queryParams.pageSize"
        @current-change="getList"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {
  queryHighTechApproval,
  highTechApprovalDelete,
  commonFileGetFileByUrl,
  enterpriseInformationRegisterQuery,
} from "./index";
export default {
  data() {
    return {
      // 搜索
      queryParams: {
        pageNum: 1,
        pageSize: 10,
      },
      // 遮罩层
      loading: true,
      total: 0,
      // 数据
      datas: [],
      status: ["未完成", "完成", "生成中", "生成失败"],
    };
  },
  created() {
    this.resetQuery();
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if ((rowIndex + 1) % 2 === 0) {
        return "background:#fff";
      } else {
        return "background:#F5F7FA";
      }
    },
    addClick() {
      this.$router.push("/centerform/ChinaHighRegistrationForm");
    },
    /** 列表 */
    getList() {
      this.loading = true;
      queryHighTechApproval(this.queryParams).then((res) => {
        this.datas = res.data.records;
        this.total = res.data.total;
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.queryParams.pageSize = 10;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("formName");
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.handleQuery();
    },
    // 日期选择
    timeChange(val) {
      this.queryParams.startTime = val[0] + " 00:00:00";
      this.queryParams.endTime = val[1] + " 23:59:59";
    },
    //删除
    handleDelete(id) {
      this.$confirm("是否确认删除项目?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return highTechApprovalDelete({ ids: [id] });
        })
        .then(() => {
          this.getList();
          this.msgSuccess("删除成功");
        })
        .catch(function () {});
    },
    // 下载
    handleDownload(url) {
      commonFileGetFileByUrl({ url: url }).then((res) => {
        window.open(res.data, "_blank");
      });
    },
  },
};
</script>
<style scoped></style>
